import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CpaCoachingIndia from "./components/CpaCoachingIndia";
import CpaCouseFeesInIndia from "./components/CpaCouseFeesInIndia";
import CpaReviewCourse from "./components/CpaReviewCourse";
import CpaStudyMaterials from "./components/CpaStudyMaterials";
import Home from "./components/Home";
import EaEnrolledAgentCourse from "./components/EaEnrolledAgentCourse";
import CpaAgentCouseFees from "./components/CpaAgentCouseFees";
import EnrolledAgentClasses from "./components/EnrolledAgentClasses";
import EnrolledAgentExam from "./components/EnrolledAgentExam";
import EaAgentSalary from './components/EaAgentSalary'
import ExamReviewCourses from './components/ExamReviewCourses'
import UsCpaExamRequirement from "./components/UsCpaExamRequirement";
import UsCpaSalary from "./components/UsCpaSalary";
import EaExamPrepration from './components/EaExamPrepration'
import EaStudyMaterials from './components/EaStudyMaterials'
import EaAgentCouseFees from './components/EaAgentCouseFees'

function App() {
  return (
    <div className="App">
      <Router basename="/projects/kcglobed/">
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/cpa-coaching-india" element={<CpaCoachingIndia />}></Route>
          <Route path="/cpa-course-fees-in-india" element={<CpaCouseFeesInIndia />}></Route>
          <Route path="/cpa-review-course" element={<CpaReviewCourse />}></Route>
          <Route path="/us-cpa-study-materials-syllabus" element={<CpaStudyMaterials />}></Route>
          <Route path="/us-enrolled-agent-courses" element={<EaEnrolledAgentCourse />}></Route>
          <Route path="/cpa-agent-couse-fees" element={<CpaAgentCouseFees />}></Route>
          <Route path="/us-enrolled-agent-classes-traning" element={<EnrolledAgentClasses />}></Route>
          <Route path="/us-enrolled-agent-exam-centers-in-india" element={<EnrolledAgentExam />}></Route>
          <Route path="/us-enrolled-agent-fees-in-india" element={<EaAgentCouseFees />}></Route>
          <Route path="/us-enrolled-agent-salary" element={<EaAgentSalary />}></Route>
          <Route path="/us-enrolled-agent-review-course" element={<ExamReviewCourses />}></Route>
          <Route path="/us-cpa-exam-requirement" element={<UsCpaExamRequirement />}></Route>
          <Route path="/us-cpa-salary" element={<UsCpaSalary />}></Route>
          <Route path="/us-enrolled-agent-exam-preparation-course" element={<EaExamPrepration />}></Route>
          <Route path="/us-enrolled-agent-study-materials-syllabus" element={<EaStudyMaterials />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
